import { useRoutes } from 'react-router-dom';
import { Navigate } from 'react-router';
// layouts
import MainLayout from 'src/layouts/main';
import PrivacyPolicy from 'src/pages/PrivacyPolicy';
import TermsAndConditions from 'src/pages/TermsAndConditions';
import ComingSoonPage from 'src/pages/coming-soon';
import ContactPage from 'src/pages/contact-us';
import HomePage from 'src/pages/home';
import HowItWorksPage from 'src/pages/how-it-works';
import AboutUsPage from 'src/pages/about-us';
import BlogPage from 'src/pages/blog';
import FeaturesPage from 'src/pages/features';
import ForRestaurantsPage from 'src/pages/for-restaurants';
import ForSuppliersPage from 'src/pages/for-suppliers';
import FAQPage from 'src/pages/faq';
import NotFoundPage from 'src/pages/404';
import { paths } from '../paths';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: paths.home,
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    {
      path: paths.forRestaurants,
      element: (
        <MainLayout>
          <ForRestaurantsPage />
        </MainLayout>
      ),
    },
    {
      path: paths.howItWorks,
      element: (
        <MainLayout>
          <HowItWorksPage />
        </MainLayout>
      ),
    },
    {
      path: paths.privacyPolicy,
      element: (
        <MainLayout>
          <PrivacyPolicy />
        </MainLayout>
      ),
    },
    {
      path: paths.termsAndConditions,
      element: (
        <MainLayout>
          <TermsAndConditions />
        </MainLayout>
      ),
    },
    {
      path: paths.contact,
      element: (
        <MainLayout>
          <ContactPage />
        </MainLayout>
      ),
    },
    {
      path: paths.aboutUs,
      element: (
        <MainLayout>
          <AboutUsPage />
        </MainLayout>
      ),
    },
    {
      path: paths.blog,
      element: (
        <MainLayout>
          <BlogPage />
        </MainLayout>
      ),
    },
    {
      path: paths.features,
      element: (
        <MainLayout>
          <FeaturesPage />
        </MainLayout>
      ),
    },
    {
      path: paths.forSuppliers,
      element: (
        <MainLayout>
          <ForSuppliersPage />
        </MainLayout>
      ),
    },
    {
      path: paths.faq,
      element: (
        <MainLayout>
          <FAQPage />
        </MainLayout>
      ),
    },
    {
      path: paths.comingSoon,
      element: (
        <MainLayout>
          <ComingSoonPage />
        </MainLayout>
      ),
    },
    {
      path: paths.page404,
      element: (
        <MainLayout>
          <NotFoundPage />
        </MainLayout>
      ),
    },
    {
      path: '*',
      element: <Navigate to={paths.page404} />,
    },
  ]);
}
